// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    burgerButton.addEventListener('click', function () {
        const isOpen = document.body.classList.toggle('gh-head-open');
        burgerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
}
